import { useDispatch, useSelector } from "react-redux";
import { useChannel, usePlayer, useA23Token } from "../data/useLobby";
import { messageToNativeClient } from "../../../Common/utils/platformCommunicationUtil";
import { PLATFORM_CHANNELS } from "../../../Poker/data/Constants";
import { processDate } from "./utilsFun";
import {
  fetchRequestTourneyRegistration,
  fetchRequestTourneyDeRegistration,
  fetchTourneyReEntry,
  updateShowTourneyRegisterOrDeregisterRequestLoading,
} from "../../../Poker/redux/slices/lobbySlice";
import useRestrictions from "../data/useRestrictions";

export default function useTourneyApiService() {
  const channel = useChannel();
  const player = usePlayer();
  const a23Token = useA23Token();
  const masterTourneysData = useSelector(
    (state) => state?.lobby?.masterTourneysData
  );
  const dispatch = useDispatch();

  const { openRestrictionDrawer, restrictionCheck, location_games } = useRestrictions();
  
  /**
   * Registers the user for a given tournament.
   * @param {string} tourneyId - The tournament ID.
   */
  const registerTourney = async (tourneyId) => {
    if (!tourneyId) {
      console.log("hari Tourney ID is required to register.");
      return { success: false, error: "Tourney ID is required" };
    }
    restrictionCheck(()=>{
      const requestPayload = {
        playerName: player?.userName,
        tourneyId,
        channel,
        appId: import.meta.env.VITE_REACT_APP_ID,
        ip: player?.IP,
        userId: player?.userId,
        profilePic: player?.avatar,
        requestor: "client",
        entryType: 1, // For register entry type is 1
        deviceId: player?.deviceId,
        state: player?.state,
        a23Token,
      };
  
      dispatch(
        updateShowTourneyRegisterOrDeregisterRequestLoading({ isLoading: true })
      );
      dispatch(
        fetchRequestTourneyRegistration({
          data: requestPayload,
          apiURL: import.meta.env.VITE_REACT_APP_TOURNEY_REGISTER_API_URL,
        })
      );
    }, true, location_games);  
  };

  /**
   * Registers the user for a given tournament.
   * @param {string} tourneyId - The tournament ID.
   */
  const deRegisterTourney = async (tourneyId) => {
    if (!tourneyId) {
      console.error("Tourney ID is required to de-register.");
      return { success: false, error: "Tourney ID is required" };
    }

    const requestPayload = {
      playerName: player?.userName,
      tourneyId,
      channel,
      appId: import.meta.env.VITE_REACT_APP_ID,
      ip: player?.IP,
      userId: player?.userId,
      profilePic: player?.avatar,
      requestor: "client",
      entryType: 3, // For deregister entry type is 3
      deviceId: player?.deviceId,
      state: player?.state,
      a23Token,
    };

    dispatch(
      updateShowTourneyRegisterOrDeregisterRequestLoading({ isLoading: true })
    );
    dispatch(
      fetchRequestTourneyDeRegistration({
        data: requestPayload,
        apiURL: import.meta.env.VITE_REACT_APP_TOURNEY_DEREGISTER_API_URL,
      })
    );
  };

  /**
   * Re-Entry for tourney id
   * @param {string} tourneyId - The tournament ID.
   */
  const reEntryTourney = async (tourneyId) => {
    if (!tourneyId) {
      console.error("Tourney ID is required for re-entry.");
      return { success: false, error: "Tourney ID is required" };
    }

    const requestPayload = {
      playerName: player?.userName,
      tourneyId,
      channel,
      appId: import.meta.env.VITE_REACT_APP_ID,
      ip: player?.IP,
      userId: player?.userId,
      profilePic: player?.avatar,
      requestor: "client",
      entryType: 2, // For reEntry entry type is 2
      deviceId: player?.deviceId,
      state: player?.state,
      a23Token,
    };

    dispatch(
      updateShowTourneyRegisterOrDeregisterRequestLoading({ isLoading: true })
    );
    dispatch(
      fetchTourneyReEntry({
        data: requestPayload,
        apiURL: import.meta.env.VITE_REACT_APP_TOURNEY_REENTRY_API_URL,
      })
    );
  };

  // TODO: working on this function
  /**
   * Registers the user for a given tournament.
   * @param {string} tourneyId - The tournament ID.
   */
  const remindMeTourney = async (tourneyId) => {
    try {
      let selectedTourneyInfoDetails = masterTourneysData?.get(tourneyId);
      if (!selectedTourneyInfoDetails) {
        return {
          success: false,
          error: "Tourney ID is not valid or does not exist",
        };
      }

      let remindMeUrl = PLATFORM_CHANNELS.includes(channel)
        ? import.meta.env
            .VITE_REACT_APP_REMINDME_DEEP_LINK_URL_FOR_STANDALONE_APP_FOR_PLATFORM_APPS
        : import.meta.env
            .VITE_REACT_APP_REMINDME_DEEP_LINK_URL_FOR_STANDALONE_APP;
      if (!selectedTourneyInfoDetails?.reminder) {
        messageToNativeClient({
          type: "RemindMe",
          data: {
            tournamentId: selectedTourneyInfoDetails?.tourneyId,
            tournmentStartTime: processDate(
              selectedTourneyInfoDetails?.tourneyStartTime
            ),
            tournamentEndTime: 0,
            regStartTime: processDate(
              selectedTourneyInfoDetails?.registrationStartTime
            ),
            tournmentName: selectedTourneyInfoDetails?.tourneyName,
            tournmentDesc: selectedTourneyInfoDetails?.tourneyDescType,
            tourneyStatus: selectedTourneyInfoDetails?.tourneyStatus,
            Game: "poker",
            remindme_deeplink_url: remindMeUrl,
          },
        });
      }
    } catch (error) {
      return { success: false, error };
    }
  };

  return {
    registerTourney,
    deRegisterTourney,
    reEntryTourney,
    remindMeTourney,
  };
}
